import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  applicants: {
    data: [],
    total: 0,
  },
  notes: {
    data: [],
    total: 0,
  },
};

const sourcingSlice = createSlice({
  name: "sourcing",
  initialState,
  reducers: {
    // -------- ALL APPLICANTS --------
    fetchAllApplicantsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAllApplicantsSuccess(state, action) {
      state.loading = false;
      state.applicants.data = action.payload.data || [];
      state.applicants.total =
        action.payload.total || action.payload.data?.length || 0;
    },
    fetchAllApplicantsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearApplicants(state) {
      state.applicants = { data: [], total: 0 };
      state.loading = false;
      state.error = null;
    },
    // updateApplicantNotes: (state, action) => {
    //   const { applicantId, newNoteUiid } = action.payload;

    //   state.applicants.data = state.applicants.data.map((a) =>
    //     a.uiid === applicantId
    //       ? { ...a, notes: [...(a.notes || []), newNoteUiid] }
    //       : a
    //   );
    // },
    getNotesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getNotesSuccess(state, action) {
      state.loading = false;
      state.notes.data = action.payload.data || [];
      state.notes.total = action.payload.total || 0;
    },
    getNotesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateApplicantNotes: (state, action) => {
      const { applicantId, newNoteUiid, note, addedBy, addedOn, uiid } =
        action.payload || {};

      const applicant = state.applicants.data.find(
        (a) => String(a.uiid) === String(applicantId),
      );
      if (!applicant) return;
      applicant.notes ??= [];
      applicant.notesList ??= [];
      const exists = applicant.notesList.some(
        (n) => String(n.uiid) === String(uiid),
      );
      if (!exists) {
        applicant.notesList.unshift({
          uiid,
          note,
          addedBy,
          addedOn,
        });
        applicant.notesList.sort(
          (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
        );
      }
      const noteExists = applicant.notes.some(
        (id) => String(id) === String(newNoteUiid),
      );

      if (!noteExists) {
        applicant.notes.push(newNoteUiid);
      }
    },
    updateApplicantWithNotes: (state, action) => {
      const { applicantId, note, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicant = state.applicants.data.find(
        (a) => String(a.uiid) === String(applicantId),
      );
      if (!applicant) return;
      applicant.notes ??= [];
      applicant.notesList ??= [];
      const noteExists = applicant.notes.some(
        (id) => String(id) === String(uiid),
      );
      if (!noteExists) {
        applicant.notes.push(uiid);
      }
      const alreadyExists = applicant.notesList.some(
        (n) => String(n.uiid) === String(uiid),
      );
      if (!alreadyExists) {
        applicant.notesList.push({
          uiid,
          note,
          addedBy,
          addedOn,
        });
      }
    },
    updateApplicantsNotesArray: (state, action) => {
      const { applicantId, notes } = action.payload || {};
      const safeNotes = Array.isArray(notes) ? notes : [];
      const noteIds = safeNotes
        .map((n) => (typeof n === "object" ? n?.uiid : n))
        .filter(Boolean);
      state.applicants.data = state.applicants.data.map((a) => {
        if (String(a.uiid) !== String(applicantId)) return a;
        return {
          ...a,
          notesList: safeNotes,
          notes: [
            ...new Set([
              ...(Array.isArray(a.notes) ? a.notes : []),
              ...noteIds,
            ]),
          ],
        };
      });
    },
  },
});

export const {
  fetchAllApplicantsStart,
  fetchAllApplicantsSuccess,
  fetchAllApplicantsFailure,
  clearApplicants,
  updateApplicantNotes,
  updateApplicantWithNotes,
  getNotesStart,
  getNotesSuccess,
  getNotesFailure,
  updateApplicantsNotesArray,
} = sourcingSlice.actions;

export default sourcingSlice.reducer;
